import Base from '@/plugins/Base';
import router from '@/plugins/Router'
import {setWithExpiry,getWithExpiry} from "@/libs/Helpers";

const module = {
    namespaced: true,
    state: () => ({
        data: {},
        expiryIn:60 * 60 * 1000 //1 saat
    }),
    getters: {
        getExpiryIn(state) {
            return state.expiryIn
        },
        getData(state) {
            return state.data
        },
        isLogin() {
            return getWithExpiry('ulmer_application_data',true)
        },
        getToken (){
            const data =getWithExpiry('ulmer_application_data',true)
            if (data)
            return data.token
        },
        goToIndex(){
            const data =getWithExpiry('ulmer_application_data',true)
            if (data && router.currentRoute.path!=='/certificates/application/form'){
                return router.push('/certificates/application/form')
            }
        },
    },
    mutations: {
        setData(state, data) {
            state.data = data
            setWithExpiry('ulmer_application_data', state.data, state.expiryIn, true)
        },

        clearData(state) {
            state.data = {}
        }
    },
    actions: {
        setSessionDeadline({state}) {
            const oneHourFromNow = new Date().getTime() + (state.expiryIn)
            setWithExpiry('ulmer_session_deadline', oneHourFromNow.toString(), 0, true)
        },
        initData({commit},formData) {
            commit('setData',formData)
        },
        logout({commit}) {
            commit('clearData')
            Base.LocalStorage.remove('ulmer_application_data')
            Base.LocalStorage.remove('ulmer_session_deadline')
            router.push('/certificates/application/login');
        }
    }
}

export default module;
